import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * First shuttle move flag.
 *
 * @remarks
 * System-managed flag set during shuttle workflow assignment. When true, indicates
 * this is the first move in a shuttle sequence, used for orchestration timing.
 */
export const schema = z.boolean().optional();

export type FirstShuttleMove = z.infer<typeof schema>;

export const definition = define({
  key: 'firstShuttleMove',
  schema,
  label: 'First Shuttle Move',
  description:
    'System flag marking this as the first move in a shuttle sequence. Set by shuttle planning, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
